import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  FormLayout,
  Heading,
  HorizontalRule,
  Paragraph,
  Section,
  IconStatusErrorOnlight,
  withTrackPage,
} from '@piggybank/core';

import { withAppContext } from '~/AppContext';

import { isButtonVisible } from './timeoutFunctions';

import nls from './nls/Timeout';
import { createTranslator } from '~/lib/nls-helper';

import getEnvironment from '~/lib/environment';

import styles from './time-out.module.css';

const environment = getEnvironment();

const NLS = createTranslator(nls);

const Timeout = ({ data }) => (
  <FormLayout>
    <Section>
      <div className={styles.error}>
        <IconStatusErrorOnlight width="2.5em" />
      </div>
      <Heading level={1}>{NLS`Application timeout`}</Heading>
      <Paragraph>{NLS`For your security, your session has expired for being inactive for more than 10 minutes.`}</Paragraph>
      <Paragraph>{NLS`Please log in again.`}</Paragraph>
    </Section>
    {isButtonVisible(data.displayData.globalData.ismobile) &&
      <Section>
        <HorizontalRule hiddenOnSmallViewport />
        <Button elementType="a" href={environment.bankingDashboardUrl}>{NLS`Start application`}</Button>
      </Section>
    }
  </FormLayout>
);

Timeout.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      globalData: PropTypes.shape({
        ismobile: PropTypes.string,
      }),
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('timeout', 'component')
)(Timeout);
